// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-buttons
  [class*='add-btn__roles']:not(
    .whole-ui-role-active .table-buttons [class*='add-btn__roles']
  ),
.table-buttons
  [class*='edit-btn__roles']:not(
    .whole-ui-role-active .table-buttons [class*='edit-btn__roles']
  ),
.table-buttons
  [class*='delete-btn__roles']:not(
    .whole-ui-role-active .table-buttons [class*='delete-btn__roles']
  ),
[class*='btn__roles']:not(
    .whole-ui-role-active [class*='btn__roles'],
    [class*='nav-btn__roles']
  ),
.task-card-transitions-btns__roles:not(
    .whole-ui-role-active .task-card-transitions-btns__roles
  ) {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/Roles.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;EAmBE,aAAa;AACf","sourcesContent":[".table-buttons\n  [class*='add-btn__roles']:not(\n    .whole-ui-role-active .table-buttons [class*='add-btn__roles']\n  ),\n.table-buttons\n  [class*='edit-btn__roles']:not(\n    .whole-ui-role-active .table-buttons [class*='edit-btn__roles']\n  ),\n.table-buttons\n  [class*='delete-btn__roles']:not(\n    .whole-ui-role-active .table-buttons [class*='delete-btn__roles']\n  ),\n[class*='btn__roles']:not(\n    .whole-ui-role-active [class*='btn__roles'],\n    [class*='nav-btn__roles']\n  ),\n.task-card-transitions-btns__roles:not(\n    .whole-ui-role-active .task-card-transitions-btns__roles\n  ) {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
